
    // this file was auto generated by python script
    import Database from './Database';
    export default Database;
    